var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDislikeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5534 22.865L20.4512 14.7627L28.5534 6.66045C29.5476 5.66623 29.5476 4.05366 28.5534 3.05944L26.7529 1.25894C25.7587 0.264721 24.1461 0.264721 23.1519 1.25894L15.0497 9.3612L6.94739 1.25894C5.95317 0.264721 4.3406 0.264721 3.34638 1.25894L1.54588 3.05944C0.551661 4.05366 0.551662 5.66623 1.54588 6.66045L9.64814 14.7627L1.54588 22.865C0.551662 23.8592 0.551662 25.4718 1.54588 26.466L3.34638 28.2665C4.3406 29.2607 5.95317 29.2607 6.94739 28.2665L15.0497 20.1642L23.1519 28.2665C24.1461 29.2607 25.7587 29.2607 26.7529 28.2665L28.5534 26.466C29.5476 25.4718 29.5476 23.8592 28.5534 22.865Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeWhite);
export default __webpack_public_path__ + "static/media/dislike-white.c0d0143b5d92f80d2449b099f333ab9f.svg";
export { ForwardRef as ReactComponent };